import { create } from 'zustand';
import { getConversationsFromDB, saveConversationToDB } from '@/services/previous-conversation.service';

export const usePreviousConversationsStore = create((set, get) => ({
  conversations: {},

  fetchConversations: async () => {
    const conversations = await getConversationsFromDB();
    const groupedConversations = conversations.reduce((acc, conv) => {
      if (!acc[conv.kb_id]) acc[conv.kb_id] = [];
      acc[conv.kb_id].push(conv);
      return acc;
    }, {});
    set({ conversations: groupedConversations });
  },

  addConversation: async (kb_id, conversation) => {
    const newConversation = { kb_id, ...conversation };
    await saveConversationToDB(newConversation);
    const updatedConversations = { ...get().conversations };
    if (!updatedConversations[kb_id]) updatedConversations[kb_id] = [];
    
    // Check if conversation already exists and update it, otherwise add it
    const existingIndex = updatedConversations[kb_id].findIndex(
      (conv) => conv.id === conversation.id && conv.interfaceType === conversation.interfaceType
    );
    
    if (existingIndex >= 0) {
      // Update existing conversation - create new array to ensure Zustand detects the change
      updatedConversations[kb_id] = [
        ...updatedConversations[kb_id].slice(0, existingIndex),
        { ...updatedConversations[kb_id][existingIndex], ...newConversation },
        ...updatedConversations[kb_id].slice(existingIndex + 1)
      ];
    } else {
      // Add new conversation
      updatedConversations[kb_id] = [...updatedConversations[kb_id], newConversation];
    }
    
    set({ conversations: updatedConversations });
  },
}));
